<template>
    <div class="info-box">
        <div :class="transformStyle(styleType)">
            <font-awesome-icon :icon="transformIcon(icon)" class="icon-styling" />
        </div>
        <div class="info-box-text">
            <div class="info-box-title">
                {{ title }}
            </div>
            <div class="info-box-content" v-html="content"></div>
            <a class="btn info-box-btn btn-zoom" :href="url" style="margin-top: 0px;">
              {{ callToAction }}
            </a>
        </div>
    </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faInfo } from '@fortawesome/free-solid-svg-icons/faInfo'
import { faPlaneDeparture } from '@fortawesome/free-solid-svg-icons/faPlaneDeparture'
import { faThumbsUp } from '@fortawesome/free-solid-svg-icons/faThumbsUp'

export default {
  name: 'Infobox',

  data: function () {
    return {
    }
  },

  components: {
    FontAwesomeIcon
  },
  methods: {
    transformIcon (icon) {
      switch (icon) {
        case 'planeDeparture': return faPlaneDeparture
        case 'thumbsUp': return faThumbsUp
        default:
        case 'info': return faInfo
      }
    },
    transformStyle (style) {
      return 'info-box-icon-' + style
    }
  },
  props: {
    icon: {
      // type: String,
      required: false,
      default: faInfo
    },
    styleType: {
      type: String,
      required: false,
      default: 'info-box-icon-dark'
    },
    title: {
      type: String,
      required: false,
      default: 'Title goes here'
    },
    content: {
      type: String,
      required: false,
      default: 'Content goes here'
    },
    url: {
      type: String,
      required: false,
      default: '#'
    },
    callToAction: {
      type: String,
      required: false,
      default: 'Call To Action goes here'
    }
  }
}
</script>

<style scoped>
.btn {
  height: 1rem;
  padding: 4px 15px 22px 15px;
}

.icon-styling {
  color: #fff;
  border: 5px solid #fff;
  border-radius: 50px;
  font-size: 40px;
  width: 70px;
  height: 70px;
  padding: 15px;
}

.info-box {
  display: flex;
  flex: column;
  margin-top: 20px;
  margin-left: 20px;
  min-height: 170px;
  width: 500px;
  padding-bottom: 20px;
  padding-top: 10px;
  padding-right: 20px;
}

.info-box:nth-child(1),
.info-box:nth-child(2) {
  border-bottom: 1px solid #000;
}

.info-box-icon-dark {
  height: 110px;
  background-color: #292d53;
  width: 110px;
  border-top-left-radius: 50px;
  border-bottom-right-radius: 50px;
  text-align: center;
  padding-top: 20px;
  order: 1;
  flex-grow: 0;
  flex-shrink: 0;
}

.info-box-icon-middle {
  height: 110px;
  background-color: #0b71b3;
  width: 110px;
  border-top-left-radius: 50px;
  border-bottom-right-radius: 50px;
  text-align: center;
  padding-top: 20px;
  order: 1;
  flex-grow: 0;
  flex-shrink: 0;
}

.info-box-icon-light {
  height: 110px;
  background-color: #5ea9d4;
  width: 110px;
  border-top-left-radius: 50px;
  border-bottom-right-radius: 50px;
  text-align: center;
  padding-top: 20px;
  order: 1;
  flex-grow: 0;
  flex-shrink: 0;
}

.info-box-text {
  margin-left: 50px;
  width: 450px;
  order: 2;
  flex-grow: 1;
  flex-shrink: 1;
}

.info-box-title {
  color: #787878;
  font-weight: bold;
  font-size: 14px;
  padding-bottom: 10px;
}

.info-box-content {
  color: #000;
  font-weight: normal;
}

.info-box-btn {
  margin-top: 10px;
  font-size: 13px;
  background-color: #ce5e31;
  color: #fff;
  border-radius: 20px;
  width: auto;
  padding-left: 10px;
}

.call-to-action-btn {
  font-size: 13px;
  background-color: #ce5e31;
  color: #fff;
  border-radius: 20px;
  width: auto;
}

ul {
  list-style: none;
  margin-left: 0px;
  padding-left: 0px;
  color: #ce5e31;
  display: table;
}

li {
  color: #000;
  font-size: 13px;
  display: table-row;
}

li:before {
  content: "\2022";  /* Add content: \2022 is the CSS Code/unicode for a bullet */
  color: #ce5e31; /* Change the color */
  font-weight: bold; /* If you want it to be bold */
  display: inline-block; /* Needed to add space between the bullet and the text */
  padding-right: 8px;
  font-size:50px;
  vertical-align:top;
  line-height:20px;
  display: table-cell;
}

/* Small devices (landscape phones, 576px and up) */
@media (max-width: 576px) {
  .info-box-icon-dark {
    display: none;
  }

  .info-box-icon-middle {
    display: none;
  }

  .info-box-icon-light {
    display: none;
  }

  .info-box {
    width: auto;
  }

  .info-box-text {
    margin-left: 10px;
    width: auto;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) {
  .info-box-icon-dark {
    display: none;
  }

  .info-box-icon-middle {
    display: none;
  }

  .info-box-icon-light {
    display: none;
  }

  .info-box {
    width: auto;
  }

  .info-box-text {
    margin-left: 10px;
    width: auto;
  }
}

/* Medium devices (tablets, 768px and up) The navbar toggle appears at this breakpoint */
@media (min-width: 768px) {
  .info-box-icon-dark {
    display: block;
  }

  .info-box-icon-middle {
    display: block;
  }

  .info-box-icon-light {
    display: block;
  }

  .info-box-text {
    margin-left: 50px;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .info-box-icon-dark {
    display: block;
  }

  .info-box-icon-middle {
    display: block;
  }

  .info-box-icon-light {
    display: block;
  }

  .info-box-text {
    margin-left: 50px;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .info-box-icon-dark {
    display: block;
  }

  .info-box-icon-middle {
    display: block;
  }

  .info-box-icon-light {
    display: block;
  }

  .info-box-text {
    margin-left: 50px;
  }
}
</style>
